import { identityScript, viewDocument } from "./document.js";

// `get_results`: the patient's results with the exact values. "Mark reviewed" opens no write of its own: it calls the
// app-only `record_review`, which Talkie asks the clinician to approve again (sensitive).
const body = `<div id="root"><p class="muted">Loading results…</p></div>`;
const script = `${identityScript}
// busy: a stale write is being re-read, so no Mark reviewed may go out at the old revision.
var root = document.getElementById("root"), state = null, ids = {}, busy = false;
function rowHtml(r, locked) {
  return '<tr><td>' + view.esc(r.name) + '</td><td>' + view.esc(r.value) + ' ' + view.esc(r.unit) + (r.flag ? ' <span class="badge warn">' + view.esc(r.flag) + '</span>' : '') +
    '</td><td>' + view.esc(r.range) + '</td><td>' + view.esc(r.collected) + '</td><td>' +
    (r.reviewed ? '<span class="badge">Reviewed</span>' : '<button data-id="' + view.esc(r.id) + '"' + (locked ? ' disabled' : '') + '>Mark reviewed</button>') + '</td></tr>';
}
function render() {
  var p = state, html = identityHtml(p.patient, p.encounter);
  html += '<h2>Results</h2><table><thead><tr><th>Test</th><th>Value</th><th>Range</th><th>Collected</th><th></th></tr></thead><tbody>';
  p.results.forEach(function (r) { html += rowHtml(r, p.encounter.signed || busy); });
  html += '</tbody></table>';
  if (!p.results.length) html += '<p class="muted">No results on file.</p>';
  if (p.awaiting_results.length) html += '<h2>Awaiting</h2><p class="muted">' + p.awaiting_results.map(function (o) { return view.esc(o.name); }).join(", ") + '</p>';
  root.innerHTML = html;
  Array.prototype.forEach.call(root.querySelectorAll("button[data-id]"), function (b) { b.onclick = function () { mark(b); }; });
  view.reportSize();
}
function mark(button) {
  var id = button.getAttribute("data-id");
  ids[id] = ids[id] || view.requestId();
  button.disabled = true;
  view.callTool("record_review", {
    patient_id: state.patient.patient_id, encounter_id: state.encounter.id, expected_revision: state.encounter.revision,
    request_id: ids[id], result_ids: [id]
  }).then(function (r) {
    if (!r.ok && r.code === "stale_revision") {
      // Every held request_id was for the old revision; a retry at the new one is a different request.
      ids = {}; busy = true; render();
      var row = function (p) { var r = p.results.filter(function (x) { return x.id === id; })[0]; return r ? rowHtml(r, false) : ""; };
      afterStale(root, "mark it reviewed", state, function () {
        return read("get_results", { patient_id: state.patient.patient_id }).then(function (d) {
          return { revision: d.encounter.revision, signed: d.encounter.signed, state: d };
        });
      }, row, function (fresh) { state = fresh; busy = false; render(); });
      return;
    }
    if (!r.ok) { render(); showStatus(root, explain(r), true); return; }
    state.encounter.revision = r.data.revision;
    state.results.forEach(function (x) { if (x.id === id) x.reviewed = true; });
    delete ids[id];
    render();
    showStatus(root, "Recorded. The encounter is now revision " + r.data.revision + ".");
  });
}
view.onResult(function (data) {
  if (!data || !data.results) { root.textContent = "No results to show."; return; }
  state = data; ids = {}; busy = false; render();
});
`;
export const resultsView = viewDocument("Results", body, script);
